import {
    SET_LANG,
    SET_LOADING,
    SET_GO_TO_PAGE,
    SET_WINDOW_SIZES,
    SET_SELECTED_PROJECT,
    SET_FIRST_TYPE_PORTFOLIO_DATA,
    SET_SECOND_TYPE_PORTFOLIO_DATA,
} from './actionTypes';

export const set_first_type_portfolio_data = data => ({
    type: SET_FIRST_TYPE_PORTFOLIO_DATA,
    payload: data,
});

export const set_second_type_portfolio_data = data => ({
    type: SET_SECOND_TYPE_PORTFOLIO_DATA,
    payload: data,
});

export const set_go_to_page = page => ({
    type: SET_GO_TO_PAGE,
    payload: page,
});

export const set_lang = lang => ({
    type: SET_LANG,
    payload: lang,
});

export const set_is_loading = state => ({
    type: SET_LOADING,
    payload: state,
});

export const set_selected_project = id => ({
    type: SET_SELECTED_PROJECT,
    payload: id,
});

export const set_window_width = ({ width, height }) => ({
    type: SET_WINDOW_SIZES,
    payload: { width, height },
});

